// @ts-nocheck
import { DropDownFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import {
    DataOption,
    DataOptions,
    getDataOptionsFieldDefinition,
    getDataOptionValue,
} from "@toolkit/Framework/Common/Utilities/dataOptions";
import { LiteralUnion } from "@toolkit/Framework/Types/Common";
import { useMemo } from "react";

export type SourceTypeOption = DataOption;
export interface SourceTypeOptionMapper {
    embed: SourceTypeOption;
    media: SourceTypeOption;
    url: SourceTypeOption;
}
export type SourceTypeOptions = DataOptions<SourceTypeOption> & SourceTypeOptionMapper;
export type SourceType = LiteralUnion<keyof SourceTypeOptionMapper>;

export const sourceTypeOptions: SourceTypeOptions = {
    embed: { id: "embed", displayName: "Embed" },
    media: { id: "media", displayName: "Media Library", isDefault: true },
    url: { id: "url", displayName: "Url" },
};

export type SourceTypeFieldValue = SourceType | undefined;
export interface SourceTypeFieldOptions {
    isChildDefinition?: boolean;
    hideEmbedOption?: boolean;
}

export const getSourceTypeFieldData = (value: SourceTypeFieldValue, options?: SourceTypeFieldOptions) => {
    if (!value) {
        return undefined;
    }

    return getDataOptionValue(sourceTypeOptions, value);
};

export const getSourceTypeFieldDefinition = (name: string, options?: SourceTypeFieldOptions) => {
    const { isChildDefinition, hideEmbedOption } = options || {};

    const dataOptions = { ...sourceTypeOptions };
    dataOptions.embed.hidden = hideEmbedOption;

    const definition: DropDownFieldDefinition<string> = {
        ...getDataOptionsFieldDefinition(dataOptions),
        name,
        displayName: "Source Type",
        fieldType: !isChildDefinition ? "General" : (undefined as any),
        hideEmptyOption: true,
    };

    return definition;
};

const getSourceTypeField = (name: string, options?: SourceTypeFieldOptions) => {
    const parse = (value: SourceTypeFieldValue) => getSourceTypeFieldData(value, options);

    return {
        definition: getSourceTypeFieldDefinition(name, options),
        parse,
        useParse: (...parameters: Parameters<typeof parse>) => {
            return useMemo(() => parse(...parameters), parameters);
        },
    };
};

export default getSourceTypeField;
